import { BulkFeeAttemptErrorResponse, CreateBulkFeeAttemptParams, CreateBulkFeeAttemptResult } from './data';

import { getCsrfToken } from '../../../csrf';

type BulkFeeAttemptSuccessResponse = { id: string };

async function parseJson<T>(response: Response): Promise<T> {
  return response.json() as Promise<T>;
}

export const createBulkFeeAttempt = async (params: CreateBulkFeeAttemptParams): Promise<CreateBulkFeeAttemptResult> => {
  const formData = new FormData();

  formData.append('file', params.csvFile);
  formData.append('name', params.name);

  const response = await fetch('/api/v1/bulk_fee_attempts', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': getCsrfToken() || '',
      'X-REQUESTED-WITH': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: formData,
  });

  if (!response.ok) {
    if (response.status === 422) {
      const errorData = await parseJson<BulkFeeAttemptErrorResponse>(response);

      return {
        success: false,
        errors: {
          csvFile: errorData.errors.csv_file,
          name: errorData.errors.name,
        },
      };
    }

    return {
      success: false,
      errors: {
        csvFile: ['Failed to upload CSV'],
      },
    };
  }

  const data = await parseJson<BulkFeeAttemptSuccessResponse>(response);
  return { success: true, data };
};

type UpdateBulkFeeAttemptParams = {
  id: string;
  csvFile: File;
};

type UpdateBulkFeeAttemptResult =
  | {
      success: true;
      data: { id: string };
    }
  | {
      success: false;
      errors: {
        csvFile?: string[];
      };
    };

export const updateBulkFeeAttempt = async (params: UpdateBulkFeeAttemptParams): Promise<UpdateBulkFeeAttemptResult> => {
  const formData = new FormData();

  const { id, csvFile } = params;
  formData.append('file', csvFile);

  const response = await fetch(`/api/v1/bulk_fee_attempts/${id}`, {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': getCsrfToken() || '',
      'X-REQUESTED-WITH': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: formData,
  });

  if (!response.ok) {
    if (response.status === 422) {
      const errorData = await parseJson<BulkFeeAttemptErrorResponse>(response);

      return {
        success: false,
        errors: {
          csvFile: errorData.errors.csv_file,
        },
      };
    }

    return {
      success: false,
      errors: {
        csvFile: ['Failed to upload CSV'],
      },
    };
  }

  const data = await parseJson<BulkFeeAttemptSuccessResponse>(response);
  return { success: true, data };
};
